import { SubscriptionsPage } from "components/KBo/Settings/SubscriptionsPage";
import React from "react";
import OrganizationBreadcrumbs from "../OrganizationBreadcrumbs";

type Props = {
    id: string;
};

/**
 * Admin intentionally renders the KBo Settings implementation so both entry
 * points present the same subscriptions and permission behavior.
 */
export default function OrganizationKboFlowSubscriptions({ id }: Props) {
    return (
        <SubscriptionsPage
            organizationId={id}
            breadcrumbs={
                <OrganizationBreadcrumbs
                    pageTitle="Subscriptions"
                    sectionLabel="KBo"
                />
            }
        />
    );
}
